import { useEffect, useState } from 'react';
import { Dialog } from './Dialog.js';
import './ui.css';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  /** the exact text the user must type to arm the confirm button */
  targetName: string;
  description?: string;
  confirmLabel?: string;
  busy?: boolean;
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  targetName,
  description,
  confirmLabel = 'Delete',
  busy = false,
}: ConfirmDialogProps) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) setTyped('');
  }, [open]);

  const armed = typed === targetName;

  return (
    <Dialog open={open} onClose={onClose} title={title} width={420}>
      <form
        className="dialog-form"
        onSubmit={(e) => {
          e.preventDefault();
          if (armed && !busy) onConfirm();
        }}
      >
        {description ? <p className="dialog-desc">{description}</p> : null}
        <p className="dialog-desc">
          Type <span className="mono confirm-target">{targetName}</span> to confirm. This cannot be
          undone.
        </p>
        <div className="field">
          <label htmlFor="confirm-typed-name">Name</label>
          <input
            id="confirm-typed-name"
            className="mono"
            autoComplete="off"
            autoFocus
            spellCheck={false}
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={targetName}
          />
        </div>
        <div className="dialog-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn btn-danger" disabled={!armed || busy}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </form>
    </Dialog>
  );
}
